/* eslint-disable */
'use strict';

const Helpers = {
    quickModalPopup: function() {
        const triggerButtons = document.querySelectorAll('.js-quick-buy-modal-trigger');
        const body = document.querySelector('body');
        const html = document.querySelector('html');

        // Function to add 'is-active' class to modal and 'prevent-scroll' class to body
        function openModal(modal) {
            modal.classList.add('is-active');
            body.classList.add('prevent-scroll');
            html.classList.add('prevent-scroll');
        }

        // Function to remove 'is-active' class from modal and 'prevent-scroll' class from body
        function closeModal(modal) {
            modal.classList.remove('is-active');
            body.classList.remove('prevent-scroll');
            html.classList.remove('prevent-scroll');
        }

        // Event listener for button click to open modal
        triggerButtons.forEach(function(button) {
            button.addEventListener('click', function() {
                const popupNum = button.dataset.popup;
                const modal = document.querySelector('.js-quick-buy-modal--' + popupNum);
                openModal(modal);
            });
        });

        // Event listener for close icon click to close modal
        // document.querySelector('.js-quick-buy-modal__close-icon').addEventListener('click', function() {
        //     // const popupNum = closeIcon.closest('.js-quick-buy-modal').dataset.popup;
        //     // const modal = document.querySelector('.js-quick-buy-modal--' + popupNum);
        //     // closeModal(modal);
        //     document.querySelector('.js-quick-buy-modal').classList.remove('is-active');
        //     body.classList.remove('prevent-scroll');
        // });

        // Event listener for clicking outside the modal to close it
        document.querySelectorAll('.js-quick-buy-modal').forEach(function(modal) {
            modal.addEventListener('click', function(event) {
                const popupNum = modal.dataset.popup;
                if (!modal.querySelector('.js-quick-buy-modal__inner').contains(event.target)) {
                    closeModal(modal);
                }
            });
        });

        // Event listener for pressing ESC key to close modal
        document.addEventListener('keydown', function(event) {
            if (event.key === 'Escape') {
                document.querySelectorAll('.js-quick-buy-modal').forEach(function(modal) {
                    const popupNum = modal.dataset.popup;
                    closeModal(modal);
                });
            }
        });
    },

    updateBWP: function(sku, quantity) {
        if (window.bwp && sku && quantity) {
            window.bwp.updateWidget(sku, parseInt(quantity));
        }
    },

    /**
     * Get the selected variant data
     * 
     * @param {string} id 
     * @returns 
     */
    getVariantData: function(id) {
        return JSON.parse(document.querySelector(`.variant-data[data-id="${id}"]`).innerHTML);
    },

    quickModalActions: function() {
        // Handle all selling plan options
        document.querySelectorAll('.quick-buy-modal__list').forEach(el => {
            el.addEventListener('click', function(e) {
                const parentElement = e.target.closest('li');
                const atcButton = document.querySelector(`.js-add-to-cart[data-product="${parentElement.dataset.product}"]`);

                atcButton.dataset.sellingPlan = parentElement.dataset.sellingPlan;
            });
        });

        // Handle all quantity buttons
        document.querySelectorAll('.quick-buy-modal__buy-input-indicator--minus').forEach(el => {
            el.addEventListener('click', function(e) {
                quantityEvent(e, 0);
            });
        });

        document.querySelectorAll('.quick-buy-modal__buy-input-indicator--plus').forEach(el => {
            el.addEventListener('click', function(e) {
                quantityEvent(e, 1);
            });
        });

        /**
         *
         * @param e Event
         * @param flag Flag to determine if the event is for the minus button or the plus button
         */
        function quantityEvent(e, flag) {
            const parentElement = e.target.closest('a');
            const quantityInput = document.querySelector(`.js-quantity-${parentElement.dataset.product}`);
            const atcButton = document.querySelector(`.js-add-to-cart[data-product="${parentElement.dataset.product}"]`);

            const value = parseInt(quantityInput.value);
            let newValue = 0;

            if (flag) {
                newValue = value + 1;
            } else {
                newValue = value - 1;
            }

            if (newValue) {
                quantityInput.value = newValue;
            }

            atcButton.dataset.quantity = newValue;
        }

        document.querySelectorAll('.js-add-to-cart').forEach(el => {
           el.addEventListener('click', function(e) {
               const data = {
                   selling_plan: e.target.dataset.sellingPlan,
                   quantity: e.target.dataset.quantity,
                   id: e.target.dataset.variant,
               };

               const url = window.location.origin + '/cart/add';

               const options = {
                   method: 'POST',
                   headers: {
                       'Content-Type': 'application/json',
                   },
                   body: JSON.stringify(data),
               };

               fetch(url, options).then((response) => {
                   // Do nothing after adding to cart
               });
           });
        });
    }
};

export default Helpers;